<template>
	<div>
		<clone-form-modal
			ref="clone_modal"
			:clone_url="clone_url"
			:company_form="true"
		></clone-form-modal>

		<list-component
			:items="forms"
			:action_url="action_url"
			toggle_property="active"
			:update_toggle_url="update_toggle_url"
			:options="options"
			@clone="cloneModal"
		></list-component>
	</div>
</template>

<script>
	import CloneFormModal from "../modals/CloneFormModal";

	export default {
		name: "CompanyFormsPage",
		components: {CloneFormModal},
		props: {
			forms: {
				type: Array,
				required: true
			},

			type: {
				type: String,
				required: true
			},

			action_url: {
				type: String,
				required: true
			},

			clone_url: {
				type: String,
				required: true
			},

			update_toggle_url: {
				type: String,
				required: true
			},
		},

		methods: {
			cloneModal(option){
				this.$refs.clone_modal.open(option.item);
			},
		},

		computed: {
			options() {
				if (this.type !== 'custom') return null;

				return [
                    {
					icon_src: '/svg/' + resource_group + '/forms.svg',
					icon_color: 'primary',
					label: 'Duplicate',

					action_url: 'clone',
					action_method: 'emit'
				},
                ];
			}
		}
	}
</script>
